export default __webpack_public_path__ + "static/4-fitness-4e3831f88633e6c068d4535d9fbe1fa2.png";